import { useQuery } from "react-query";
import { IDataDetalharLimiteCredUtilizado } from "../../../../types/api/geral/detalhar-limite-credito-utilizado";
import axiosClient from "../../../../lib/axios";
import LoadingApiQuery from "../../../../components/LoadingApiQuery";
import moment from "moment";
import { formatarValorMonetario } from "../../../../helpers/masks";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export default function DialogLimiteUtilizado({
    publico_id,
    open,
    handleClose
}: DialogLimiteUtilizadoProps) {

    const { data, isLoading } = useQuery({
        queryKey: ['detalhar-limite-credito-utilizado', publico_id],
        queryFn: () => axiosClient.get("/detalhar-limite-credito-utilizado", {
            params: {
                publico_id,
            }
        })
    });
    const dadoLimiteUtilizado: IDataDetalharLimiteCredUtilizado[] = data?.data || []

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle>Limite de crédito utilizado</DialogTitle>
            <DialogContent>
                {
                    isLoading && <LoadingApiQuery extraParams={{ minHeight: 200, alignItems: "center" }} />
                }
                {
                    !isLoading &&
                    <TableContainer sx={{ maxHeight: 400 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    {headers.map((item, index) => {
                                        return (
                                            <TableCell key={index} align={item.numeric ? 'right' : 'left'} sx={{ paddingX: 1 }} width={item.width}>
                                                <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dadoLimiteUtilizado.length > 0 && dadoLimiteUtilizado.flatMap(row => {
                                    if (row.ocorrencias && row.ocorrencias.length > 0) {
                                        return row.ocorrencias.map((ocorrencia, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell sx={{ paddingX: 1 }}>
                                                    {ocorrencia.tipo}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 1 }}>
                                                    {ocorrencia.identificador}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 1 }}>
                                                    {moment(ocorrencia.data_emissao).format('DD/MM/YYYY')}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 1 }}>
                                                    {moment(ocorrencia.data_vencimento).format('DD/MM/YYYY')}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 1 }} align="right">
                                                    {formatarValorMonetario(ocorrencia.valor_original)}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 1 }} align="right">
                                                    {formatarValorMonetario(ocorrencia.valor_atualizado)}
                                                </TableCell>
                                            </TableRow>
                                        ));
                                    }
                                    return (
                                        <TableRow>
                                            <TableCell colSpan={headers.length} align="center">
                                                <Typography variant="body2" color="text.secondary">Nenhum limite de crédito utilizado encontrado.</Typography>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogLimiteUtilizadoProps {
    publico_id: string;
    open: boolean;
    handleClose: VoidFunction
}

const headers = [
    {
        label: "Tipo",
        numeric: false,
        width: '16%'
    },
    {
        label: "Identificador",
        numeric: false,
        width: '16%'
    },
    {
        label: "Data emissão",
        numeric: false,
        width: '16%'
    },
    {
        label: "Data vencimento",
        numeric: false,
        width: '16%'
    },
    {
        label: "Valor original",
        numeric: true,
        width: '16%'
    },
    {
        label: "Valor atualizado",
        numeric: true,
        width: '16%'
    }
]
